import { AbstractControl } from '@angular/forms';
import { GenericAccountValidator } from './generic-account-validator';

export class EuropeBankAccountValidator extends GenericAccountValidator {
    protected static errors: any = {
        'es-AR': {
            bad_email: 'IBAN incorrecto, debe ser por ejemplo: ES6621000418401234567891'
        },
        'en-US': {
            bad_email: 'Incorrect IBAN, here`s an example: ES6621000418401234567891'
        }
    };
    protected static label: any = {
        'es-AR': 'IBAN para',
        'en-US': 'IBAN for'
    };
    protected static placeholder: any = {
        'es-AR': 'Por ejemplo: ES6621000418401234567891',
        'en-US': 'For example: ES6621000418401234567891'
    };

    public getLabelToAccountType(): string {
        return EuropeBankAccountValidator.label[EuropeBankAccountValidator.lang] ?? EuropeBankAccountValidator.label['es-AR'];
    }

    public getPlaceholderToAccountType(): string {
        return EuropeBankAccountValidator.placeholder[EuropeBankAccountValidator.lang] ?? EuropeBankAccountValidator.placeholder['es-AR'];
    }

    public accountValidate(control: AbstractControl): { [key: string]: any } | null {
        let error: any = EuropeBankAccountValidator.errors[EuropeBankAccountValidator.lang] ?? EuropeBankAccountValidator.errors['es-AR'];
        let value: any = control.value.replace(/ /g, '');
        if (/^[A-Z]{2}\d{2}[A-Z0-9]{4}[0-9]{7,23}/.test(value)) {
            return null;
        }

        return { forbiddenName: error.bad_email };
    }
}
